import { z } from 'zod';

export const axisSchema = z.object({
  id: z.number().int(),
  nome: z.string(),
  ordem: z.number().int(),
  notaMaxima: z.coerce.number().nullable(),
  notaMedia: z.coerce.number().nullable(),
  notaUltima: z.coerce.number().nullish(),
});

export type Axis = z.infer<typeof axisSchema>;

export const conceptSchema = z.object({
  conceitoId: z.number().int(),
  referencia: z.enum(['pessimo', 'precario', 'razoavel', 'mediano', 'bom', 'otimo']),
});

export type Concept = z.infer<typeof conceptSchema>;

export const performanceByCompetenceResponseSchema = z.object({
  conceitos: z.array(conceptSchema),
  eixos: z.array(axisSchema),
  ocultaNota: z.boolean().optional(),
  interpretacao: z.string().nullish(),
});

export type PerformanceByCompetenceResponse = z.infer<typeof performanceByCompetenceResponseSchema>;
